import { render } from "./Mihadhara.vue?vue&type=template&id=af65cb4c&scoped=true"
import script from "./Mihadhara.vue?vue&type=script&lang=js"
export * from "./Mihadhara.vue?vue&type=script&lang=js"

import "./Mihadhara.vue?vue&type=style&index=0&id=af65cb4c&scoped=true&lang=css"

import exportComponent from "/pro/vue/Attamayyuz_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af65cb4c"]])

export default __exports__